import {Component, OnInit} from '@angular/core';
import {PrinterHttpService} from "../_services/printer-http.service";
import {PrinterDto} from "../_models/printer-dto";
import {GlobalAlertService} from "../../../_services/global-alert.service";
import {AlertLevel} from "../../../enums/alert-level";
import {PrinterType} from "../_models/_enums/printer-type";
import {AppRoutes} from "../../../enums/routes";
import {Router} from "@angular/router";
import {LocationRoutes} from "../_models/_enums/location-routes";
import {PermissionService} from "../../../_auth/permission.service";
import {CommonModule, DatePipe} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-printers',
  templateUrl: './printers.component.html',
  imports: [
    CommonModule,
    FormsModule,
    DatePipe
  ],
  styleUrls: ['./printers.component.scss']
})
export class PrintersComponent implements OnInit {
  printers: PrinterDto[] | undefined;
  filtered: PrinterDto[] | undefined;
  name: string = "";
  connectionString = "";
  protected readonly PrinterType = PrinterType;

  constructor(private printerHttpService: PrinterHttpService, private gas: GlobalAlertService, private router: Router,
              public PermissionService: PermissionService) {
  }

  load() {
    this.printerHttpService.list().subscribe({
      next: printers => {
        this.printers = printers;
        this.filter();
      },
      error: err => {
        console.error(err);
        this.gas.createAlertBannerModel("Fehler", "Beim Laden der Drucker ist ein Fehler aufgetreten.", AlertLevel.error);
      }
    })
  }

  filter() {
    if (!this.printers) {
      this.filtered = undefined;
      return;
    }

    if (this.name == "") {
      this.filtered = Object.assign([], this.printers);
    } else {
      this.filtered = Object.assign([], this.printers.filter(x => x.name.toLowerCase().includes(this.name.trim().toLowerCase())))
    }
  }

  toSettings(id: string) {
    this.router.navigate([AppRoutes.LocationModule + '/' + LocationRoutes.PrinterSettings], {
      queryParams: {
        id: id
      }
    }).then();
  }

  add() {
    if (this.name.trim() == "" || this.connectionString.trim() == "") {
      this.gas.createAndShow("Fehler", "Name und Verbindungszeichenfolge dürfen nicht leer sein.", AlertLevel.error);
      return;
    }

    this.printerHttpService.add(this.name, this.connectionString).subscribe({
      next: printer => {
        this.name = "";
        this.connectionString = "";

        if (!this.printers) this.printers = [];
        this.printers?.splice(0, 0, printer);

        this.filter();
      },
      error: err => {
        console.error(err);
        this.gas.createAndShow("Fehler", "Beim Hinzufügen des Druckers ist ein Fehler aufgetreten.", AlertLevel.error);
      }
    })
  }

  ngOnInit(): void {
    this.load();
  }
}
